import { memo } from "react";
import { createUseStyles } from "react-jss";
import { EuiLoadingSpinner } from "@elastic/eui";

const useStyles = createUseStyles({
  loader_wrapper: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
});

const DashboardLoader = ({ noWrapper = false, size = "l" }: any) => {
  const classes = useStyles();
  return noWrapper ? (
    <EuiLoadingSpinner size={size} />
  ) : (
    <div className={classes.loader_wrapper}>
      <EuiLoadingSpinner size={size} />
    </div>
  );
};

export default memo(DashboardLoader);
